<template>
  <div>
    <me-header :hlist="meList" v-transition></me-header>
    <me-balance :blist="balanceList" v-transition></me-balance>
    <!-- <me-icons v-transition></me-icons> -->
    <me-trade v-transition></me-trade>
    <me-service :shopid="shopid" v-transition></me-service>
    <me-device v-transition></me-device>
    <me-quit v-transition></me-quit>
    <me-footer v-transition></me-footer>
  </div>
</template>

<script>
import MeHeader from './components/Header'
import MeBalance from './components/Balance'
import MeIcons from './components/Icons'
import MeTrade from './components/Trade'
import MeService from './components/Service'
import MeDevice from './components/Device'
import MeQuit from './components/Quit'
import MeFooter from './components/Footer'
export default {
  name: 'Me',
  components: {
    MeHeader,
    MeBalance,
    MeIcons,
    MeTrade,
    MeService,
    MeDevice,
    MeQuit,
    MeFooter
  },
  data () {
    return {
      meList: [],
      balanceList: [],
      shopid: ''
    }
  },
  methods: {
    getMeInfo () {
      this.axios.get('/ApiMe/GetModel')
        .then(this.getMeInfoSucc)
    },
    getMeInfoSucc (res) {
      console.log(res)
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.meList = JSON.parse(data.meList)
        this.shopid = JSON.parse(data.meList)[0].id
        this.balanceList = JSON.parse(data.balanceList)
        console.log(this.meList)
      }
    }
  },
  mounted () {
    this.getMeInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/me/Me.vue